var React = require('react');

function Alarm (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.508 14.758a1.492 1.492 0 1 0 2.984 0H5.508zm6.652-3.143V7.25a5.155 5.155 0 0 0-3.967-5.018v-.54A1.19 1.19 0 0 0 7 .5a1.19 1.19 0 0 0-1.192 1.192v.54A5.155 5.155 0 0 0 1.84 7.25v4.365l-1.59 1.59V14h13.5v-.795l-1.59-1.59z","fill":"currentColor","fillRule":"evenodd"}));
}

Alarm.defaultProps = {"width":"14","height":"17","viewBox":"0 0 14 17"};

module.exports = Alarm;

Alarm.default = Alarm;
